import React from 'react'
import { Box } from 'pcln-design-system'
import { FilterSkeleton } from '@pcln/fly-ui-components'
import styled from 'styled-components'

const StyledFilterSkeleton = styled(FilterSkeleton)`
  line-height: 20px;
  ${typeof window === 'undefined' && 'margin-top: 24px;'}
`

const LeftFilterSkeleton = () => {
  return (
    <Box pl={1} pt={'9px'}>
      <StyledFilterSkeleton showTitles repeat={4} sectionTitles={['Stops', 'Airlines', 'Time', 'Airports']} />
    </Box>
  )
}

LeftFilterSkeleton.displayName = 'FilterSkeleton'

export { LeftFilterSkeleton }
